import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Container } from './Container';
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="bg-paper pb-16 pt-2 sm:pb-24" data-id="element-86" data-mp="1o2vjmvsbez9q">
      <Container narrow data-id="element-87" data-mp="2223jzs07sdfi">
        <div className="relative rounded-xl2 border border-hairline bg-white p-6 pt-9 shadow-paper sm:p-10 sm:pt-12" data-id="element-88" data-mp="222mzl22e6pqd">
          <span aria-hidden="true" className="tape" data-id="element-89" data-mp="1x2igd4a3ngwg" />

          <div className="flex flex-col items-center gap-6 text-center sm:flex-row sm:items-start sm:gap-8 sm:text-left" data-id="element-90" data-mp="19fiukx3aubel">
            <div className="flex h-16 w-16 flex-none items-center justify-center rounded-2xl bg-sageSoft" data-id="element-91" data-mp="14hh6tyuxhnws">
              <ShieldCheckIcon className="h-8 w-8 text-sage" aria-hidden="true" data-id="element-92" data-mp="1j6n43ha7h421" />
            </div>

            <div data-id="element-93" data-mp="1ebr5tzedlkgh">
              <span className="inline-flex items-center rounded-full border border-hairline bg-paper px-3.5 py-1.5 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-ink" data-id="element-94" data-mp="qo9eu62xqqek">
                7-Day Guarantee
              </span>
              <h2 id="guarantee-heading" className="mt-4 font-display text-[28px] font-bold leading-[1.14] tracking-[-0.02em] text-ink sm:text-[36px]" data-id="element-95" data-mp="oyqdc7f0ntim">
                Try It for 7 Days.
                <span className="pop-sm-blue block" data-id="element-96" data-mp="yrflasbcyp97">You’re Protected.</span>
              </h2>
              <p className="mt-4 max-w-[560px] text-[17px] leading-[1.65] text-muted" data-id="element-97" data-mp="12t0uo3ooolen">
                Download the kit, explore the projects and see how it fits into your family’s
                routine. If it isn’t what you expected, contact us within 7 days and we’ll honor our
                guarantee.
              </p>
            </div>
          </div>
        </div>
      </Container>
    </section>;
}